import { render, staticRenderFns } from "./SummaryPanel.vue?vue&type=template&id=62bb50d0&scoped=true&"
import script from "./SummaryPanel.vue?vue&type=script&lang=js&"
export * from "./SummaryPanel.vue?vue&type=script&lang=js&"
import style0 from "./SummaryPanel.vue?vue&type=style&index=0&id=62bb50d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62bb50d0",
  null
  
)

export default component.exports